import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { useNavigate} from 'react-router-dom';
import Stack from '@mui/material/Stack';
import {useSelector } from 'react-redux';
import ListSubheader from '@mui/material/ListSubheader';
export default function Navbar() {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const navigate=useNavigate();
  const userId=useSelector(state=>state.driver.entities.currDriver?.driverId);
  const driverJobTitle=useSelector(state=>state.driver.entities.currDriver?.driverJobTitle);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleCloseWithoutNavigate = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    
    setOpen(false);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
    navigate(event.target.id)
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }
  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);

  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed">
        <Toolbar>
        <Stack direction="row" spacing={2}>
            <IconButton
            ref={anchorRef}
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            aria-controls={open ? 'composition-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Popper
          open={open}
          anchorEl={anchorRef}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom-start' ? 'left top' : 'left bottom',
              }}
            >
              <Paper className='navbar-container'>
                <ClickAwayListener onClickAway={handleCloseWithoutNavigate}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                    className="navbar"
                    style={{marginTop:"80px"}}
                  >
                    <MenuItem onClick={handleClose} id={userId?userId+"/":"error/error"}> Home</MenuItem>
                    <ListSubheader sx={{fontSize:"1rem", fontWeight:"600", backgroundColor:"black", color:"white"}}>HP 06 Daily Delivery Report (HACCP)</ListSubheader>
                    <MenuItem onClick={handleClose} id={userId?userId+"/haccp/create":"error/error"}> Create New</MenuItem>
                    <MenuItem onClick={handleClose} id={userId?userId+"/haccp/view":"error/error"}>Reports</MenuItem>
                  {driverJobTitle && !driverJobTitle.toLowerCase().includes("contractor") && [
                    <ListSubheader key="whs-header" sx={{ fontSize: "1rem", fontWeight: "600", backgroundColor: "black", color: "white" }}>
                      DN 010.4 Motor Vehicle Inspection (WHS)
                    </ListSubheader>,
                    <MenuItem key="whs-create" onClick={handleClose} id={userId ? userId + "/whs/create" : "error/error"}>
                      Create New
                    </MenuItem>,
                    <MenuItem key="whs-view" onClick={handleClose} id={userId ? userId + "/whs/view" : "error/error"}>
                      Reports
                    </MenuItem>
                  ]}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
    </Stack>
         
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontSize:"1.1rem", cursor:"pointer"}} onClick={()=>navigate(userId?userId+"/":"error/error")}>
           Driver Check - The Fruit Box
          </Typography>
        </Toolbar>
      </AppBar>
    </Box>
  );
}